import { createContext, useContext } from "react";

import type { OrderShift, Shift } from "~/providers/shift-provider";

interface ShiftContext {
  shifts: Shift[];
  orderShifts: OrderShift[];
  openShiftDialog: (shift?: Shift) => void;
  openOrderShiftDialog: (shift?: OrderShift) => void;
}

export const ShiftContext = createContext<ShiftContext | undefined>(undefined);

export const useShift = () => {
  const context = useContext(ShiftContext);
  if (context === undefined) {
    throw new Error(
      "useShift must be used within a ShiftProvider, but no provider was found",
    );
  }

  return context;
};
